import { useState } from "react";
import clienteAxios from "../../../config/axios";
import AlertWarning from "../../CustomAlerts/AlertWarning";
import AlertSuccess from "../../CustomAlerts/AlertSuccess";
import { format, add, sub } from "date-fns";
import { tipoConcesion } from "../../shared/Helpers/CalculosConcesiones";
import { CuotasDetalle } from "../../../functions/Validaciones/CuotasDetalle";

import { CuotaDeuda } from "../../../functions/Validaciones/CuotaDeuda";
import { CalculoCuota } from "../../../functions/FunctionCuota";
import { useEffect } from "react";
import Swal from "sweetalert2";
import "./PanelStyles.css";

const dateExtra = () => {
  return format(add(new Date(), { days: 1 }), "yyyy-MM-dd").toString();
};

const PanelJudicial = ({ juicio, setJuicio, setSteps, steps, setComprobante, setPago }) => {
  //formularios
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    //PAGO
    estado: "PARCIAL",
    forma_pago: "",
    fecha_importe: "",
    importe: 0,
    exmonto: juicio.exmonto,
    deuda: juicio.deuda,
    interes_moratorio: juicio.interes,
    //judicial
    judicial_id: juicio.id,
    comentarios: "",
  });

  const {
    id,
    id_persona,
    id_cajero,
    punto_venta_id,
    interes_punitorio,
    interes_moratorio,
    fecha_otorgamiento,
    item,
    monto,
    deuda,
    updated_at,
  } = juicio;

  const onClick = async (e) => {
    switch (e.target.name) {
      case "pagar":
        {
          if (form.forma_pago == "") {
            return AlertWarning({
              message: "La forma de pago es obligatoria",
              title: "Danger",
            });
          }
          if (form.importe <= 0) {
            return AlertWarning({
              message: "El importe debe ser mayor a 0",
              title: "Danger",
            });
          }

          let vuelto = 0;
          if (form.importe > deuda) {
            setForm({
              ...form,
              importe: deuda,
            });
            vuelto = form.importe - deuda;
          }

          let reporte = {
            //PAGO
            vuelto: vuelto,
            estado: form.estado,
            forma_pago: form.forma_pago,
            fecha_importe: format(new Date(), "yyyy-MM-dd").toString(),
            importe: vuelto > 0 ? deuda : form.importe,
            exmonto: juicio.exmonto,
            deuda: juicio.deuda,
            interes_moratorio: juicio.interes,
            //judicial
            judicial_id: juicio.id,
            comentarios: "",
          };

          setLoading(true);
          try {
            const result = await clienteAxios.post(
              "/PagosJudicial/store",
              reporte
            );
            AlertSuccess({ message: "Pago realizado!" });

            if (vuelto > 0) {
              Swal.fire({
                title: "Vuelto $" + vuelto,
                icon: "success",
              });
            }

            setSteps(steps + 1);
            setPago({
              pago: reporte,
              cuota: juicio,
            });
            setJuicio(null);
            setComprobante(true)
          } catch (e) {
            setLoading(false);
            AlertWarning({
              message: "",
              title: "Danger",
            });
          }
        }
        break;
    }
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "importe":
        {
          let estado = "PARCIAL";
          let importe = parseFloat(e.target.value);
          if (importe > deuda) {
            estado = "EXCEDENTE";
          }

          if (importe < deuda) {
            estado = "PARCIAL";
          }

          if (importe == deuda) {
            estado = "TOTAL";
          }

          setForm({
            ...form,
            estado: estado,
            importe: importe,
          });
        }
        break;
      case "forma_pago":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
    }
  };

  useEffect(() => {
    setForm({
      ...{
        //PAGO
        estado: "PARCIAL",
        forma_pago: "",
        fecha_importe: "",
        importe: 0,
        monto: juicio.deuda,
        interes_moratorio: juicio.interes,
        //judicial
        judicial_id: juicio.id,
        comentarios: "",
      },
    });
  }, [juicio]);
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="modern-panel">
      {/* Header */}
      <div className="panel-header" style={{ background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)" }}>
        <i className="bi bi-exclamation-triangle me-3"></i>
        <h2>Pagar Gasto Judicial</h2>
      </div>

      {/* Form Section */}
      <div className="panel-form-section">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-currency-dollar me-2"></i>
                Total a Pagar
              </label>
              <input
                type="text"
                className="form-control-modern form-control-readonly"
                value={"$ " + formatCurrency(form.monto)}
                disabled
                style={{ fontSize: "1.75rem", fontWeight: "700", textAlign: "center" }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-cash-stack me-2"></i>
                Forma de Pago
              </label>
              <select
                className="form-control-modern"
                name="forma_pago"
                onChange={(event) => onChange(event)}
                style={{ fontSize: "1.1rem" }}
              >
                <option value="">Seleccionar...</option>
                <option value="efectivo">Efectivo</option>
                <option value="tarjeta">Tarjeta</option>
                <option value="cheque">Cheque</option>
                <option value="Judicial">Judicial</option>
                <option value="Bancario">Bancario</option>
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-check-circle me-2"></i>
                Estado del Pago
              </label>
              <input
                type="text"
                className="form-control-modern form-control-readonly"
                value={form.estado}
                disabled
                style={{ textAlign: "center", fontWeight: "600" }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-calculator me-2"></i>
                Importe
              </label>
              <input
                type="number"
                step="0.01"
                className="form-control-modern"
                placeholder="0.00"
                name="importe"
                onChange={(event) => onChange(event)}
                value={form.importe}
                style={{ fontSize: "1.1rem" }}
              />
            </div>
          </div>
        </div>

        <button
          className="btn-pagar-modern"
          style={{ background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)" }}
          name="pagar"
          onClick={(event) => onClick(event)}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle-fill me-2"></i>
              Pagar
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default PanelJudicial;
